var _desc, _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarJetsMultiplayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 560",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "WAR JETS P2P Multiplayer project thumbnail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Neon arcade space battle scene with glowing jets and multiplayer game HUD.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "spaceGlow",
    cx: "50%",
    cy: "46%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#16284a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopColor: "#071426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyanJet",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4cf4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    stopColor: "#00a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0069ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magentaJet",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff4df7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#bd00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4e006c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cyanGlow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "magentaGlow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "textGlow",
    x: "-30%",
    y: "-60%",
    width: "160%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "url(#spaceGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    stroke: "#14375e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0v560M210 0v560M340 0v560M470 0v560M600 0v560M730 0v560M860 0v560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 70h900M0 150h900M0 230h900M0 310h900M0 390h900M0 470h900"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#c7efff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 2.4,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 156,
    r: 1.9,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 82,
    r: 3,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 210,
    r: 2.2,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 94,
    r: 1.8,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632,
    cy: 188,
    r: 2.7,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782,
    cy: 118,
    r: 2.2,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 836,
    cy: 292,
    r: 1.7,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 365,
    r: 2.1,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 446,
    r: 3.1,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496,
    cy: 424,
    r: 2.6,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 384,
    r: 2,
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(451 128)",
    filter: "url(#magentaGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-76c34 56 46 119 35 188H-35C-46 43-34-20 0-76Z",
    fill: "url(#magentaJet)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 8-138 67l22 46 87-34Z",
    fill: "#72007e",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8 138 67l-22 46-87-34Z",
    fill: "#72007e",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 111 0 168l16-57Z",
    fill: "#ff55f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -36,
    r: 15,
    fill: "#4b005d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -64,
    cy: 116,
    r: 12,
    fill: "#ff00f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 116,
    r: 12,
    fill: "#ff00f5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 393)",
    filter: "url(#cyanGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-56c26 42 35 90 26 140h-52C-35 34-26-14 0-56Z",
    fill: "url(#cyanJet)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26 10-101 52l16 34 64-25Z",
    fill: "#0096c9",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 10 101 52 85 86 21 61Z",
    fill: "#0096c9",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 83 0 132l12-49Z",
    fill: "#ff9d1f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -18,
    r: 12,
    fill: "#012b54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -18,
    r: 5,
    fill: "#62f7ff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#textGlow)",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 286,
    fill: "#ff2df4",
    fontSize: 45,
    letterSpacing: 3
  }, "WAR JETS"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 329,
    fill: "#32edff",
    fontSize: 24,
    letterSpacing: 5
  }, "P2P MULTIPLAYER"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 22
  }, /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 48,
    fill: "#19dfff",
    filter: "url(#cyanGlow)"
  }, "harshad \u2605"), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 31,
    width: 142,
    height: 16,
    fill: "#00ff5a",
    filter: "url(#cyanGlow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 656,
    y: 49,
    fill: "#ff53f0",
    filter: "url(#magentaGlow)"
  }, "\u26A1 OVERLOAD"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarJetsMultiplayer);
export default __webpack_public_path__ + "static/media/war-jets-multiplayer.3a14437758531f22e7dfd1cef6acaa27.svg";
export { ForwardRef as ReactComponent };